import $ from "jquery";
import simpleParallax from "simple-parallax-js"; // eslint-disable-line

// scroll into view event handler
const scrollIntoViewHandler = ($element) => {
    $element.one("transitionend", () => {
        setTimeout(() => {
            $element
                .get(0)
                .scrollIntoView({ behavior: "smooth", block: "start" });
        }, 350);
    });
};

const init = (opts = {}) => {
    const defaults = {
        selector: {
            module: ".js-usp",
            trigger: ".js-usp-trigger",
            link: ".usp__link",
            content: ".usp__content",
            linkContent: ".usp__link-content",
            linkContentInner: ".usp__link-content-inner-wrapper",
            preload: ".preload",
            images: "img",
            active: ".is-active",
        },
        attribute: {
            image: "data-bg-image",
        },
        state: {
            active: "is-active",
        },
        breakpoint: {
            mobile: 767,
        },
        event: {
            click: "click.usp",
            resize: "resize.usp",
            scroll: "scroll.usp",
            mouseenter: "mouseenter.usp",
        },
    };

    // merge options
    const options = $.extend(true, defaults, opts);

    // cache elements
    const $window = $(window);
    const $module = $(options.selector.module);
    const $preload = $module.find(options.selector.preload);
    const $images = $preload.find(options.selector.images);
    const initialActiveIndex = $module
        .find(`${options.selector.link}.${options.state.active}`)
        .index();

    // if no module find, return
    if (!$module.length) return;

    // bind event handlers
    $module.on(options.event.click, options.selector.trigger, function (event) {
        event.preventDefault();

        const $link = $(this).parent("li");
        const $active = $module.find(
            `${options.selector.link}.${options.state.active}`,
        );
        const image = $link.attr(options.attribute.image);
        const activeIndex = $link.index();

        // change background image
        $images
            .removeClass(options.state.active)
            .eq(activeIndex)
            .addClass(options.state.active);

        // set state
        $active.removeClass(options.state.active);
        $link.addClass(options.state.active);
        if ($window.width() <= options.breakpoint.mobile && $link.is($active))
            $link.toggleClass(options.state.active);

        // set background image
        $module.css("background-image", `url(${image})`);

        // trigger resize
        $window.trigger(options.event.resize);
    });

    // initial background image load
    const $active = $module.find(
        `${options.selector.link}.${options.state.active}`,
    );
    const image = $active.length ? $active.attr(options.attribute.image) : null;
    if ($window.width() <= options.breakpoint.mobile && image)
        $module.css("background-image", `url(${image})`);

    // resize height scaling
    $window
        .on(options.event.resize, function () {
            let $activeElm = $module.find(
                `${options.selector.link}.${options.state.active}`,
            );
            const scrollIntoView = $activeElm.length ? true : false;
            const mobile = window.matchMedia(
                `(max-width: ${options.breakpoint.mobile}px)`,
            ).matches;

            // responsive fallback when mobile accordions are collapsed, default to initial active item
            if (!$activeElm.length)
                $activeElm = $module
                    .find(options.selector.link)
                    .eq(initialActiveIndex);

            // set default if not found
            if (!mobile) $activeElm.addClass(options.state.active);

            // set height
            const $content = $activeElm.parents(options.selector.content);
            $content.removeAttr("style");
            const height = $activeElm
                .find(options.selector.linkContentInner)
                .outerHeight();
            $content.css("min-height", height);

            // scroll into view
            if (mobile)
                scrollIntoViewHandler(scrollIntoView ? $active : $module);
        })
        .trigger(options.event.resize);

    // parallax effect
    $window.on(options.event.scroll, function () {
        const rect = $preload.get(0).getBoundingClientRect();
        let position = rect.top + rect.height;
        position /=
            ($(window).scrollTop(), $(window).width(), $(window).height()) +
            rect.height;
        position = position * 100;

        if (position >= 0 && position <= 100) {
            const reposition = (position + 0.5) * -1;
            $preload
                .find("img")
                .css({ transform: `translate3d(-50%, ${reposition}%, 0)` });
        }
    });

    // [TODO]: load image on mouseenter
    // ...
};

export default { init };
